import { updateAvatar } from "@/app/api/dynabuy-back/api-profile";

const NEW_API_ADRESSE_URL = "https://data.geopf.fr/geocodage/search/";

export const fetchAdresses = async <T>(
  value: string,
  setStreet: (features: T) => void,
) => {
  try {
    const url = new URL(NEW_API_ADRESSE_URL);
    const params = new URLSearchParams(url.search);
    params.set("q", value);
    const adresses = await fetch(url + "?" + params.toString());
    setStreet(await adresses.json().then((res) => res.features));
  } catch {}
};

export const handleFile = async (
  file: File,
  inputRef: { current: { value: string | null } },
  url: string,
  setUrl: (url: string) => void,
) => {
  inputRef.current.value = null;
  if (url == "") {
    const newUrl = URL.createObjectURL(file);
    setUrl(newUrl);
  }
  if (file) {
    const newUrl = URL.createObjectURL(file);
    if (url !== newUrl) {
      setUrl(newUrl);
    }
  }
  const formData = new FormData();
  formData.append("file", file);
  await updateAvatar(formData);
};
